import { useLayoutEffect } from 'react';

import { terminateDataChecksWorker } from 'services/datachecks/datachecks';
import { cleanStore } from 'stores/tasks/tasks';
import { resetPreviousTaskResponse } from 'components/TaskForm/hooks/getTaskUiConfig';

export const useInitTaskStore = () => {
  useLayoutEffect(() => {
    cleanStore();
    return () => {
      cleanStore();
      resetPreviousTaskResponse();
      terminateDataChecksWorker();
    };
  }, []);
};
